import { render, staticRenderFns } from "./Conocenos.vue?vue&type=template&id=5927225f"
import script from "./Conocenos.vue?vue&type=script&lang=js"
export * from "./Conocenos.vue?vue&type=script&lang=js"
import style0 from "./Conocenos.vue?vue&type=style&index=0&id=5927225f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports